<template>
  <div>
    <v-list-item v-if="listItem" :title="$t('documentation.title')" @click="dialog = true">
      <v-list-item-icon class="mr-1">
        <v-icon small>fas fa-question-circle</v-icon>
      </v-list-item-icon>

      <v-list-item-content>
        <v-list-item-title>{{ $t(`documentation.menu_name`) }}</v-list-item-title>
      </v-list-item-content>
    </v-list-item>

    <v-btn v-else :title="$t('documentation.title')" icon @click="dialog = true">
      <v-icon small>fa-question-circle</v-icon>
    </v-btn>

    <v-dialog v-model="dialog" width="750">
      <v-card>
        <v-card-title class="headline grey lighten-2" primary-title>
          {{ $t("documentation.preview.title") }}
        </v-card-title>

        <v-card-text v-html="parsed"></v-card-text>

        <v-divider></v-divider>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary" text @click="dialog = false">
            {{ $t("common.close") }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import parser from "../../../../mixins/parser"

export default {
  name: "DocumentationDialogue",
  mixins: [parser],
  props: {
    listItem: { type: Boolean, default: false, required: false },
    path: { required: true, type: String },
  },
  data: () => ({
    dialog: false,
    documentation: {},
  }),
  computed: {
    isSecuratingAccount() {
      return this.$store.state.auth.user["doc"] === true
    },
  },
  mounted() {
    this.$axios
      .get("office/common/documentations/by?path=" + encodeURIComponent(this.path))
      .then(response => {
        this.documentation = response.data.data

        const locale = this.$i18n.locale.toLowerCase()

        this.parse(this.documentation[`content_${locale}`])

        this.parsed = this.parsed + `<br>Documentation : <b class='green--text'>${this.path}</b>`
      })
      .catch(() => {
        if (this.isSecuratingAccount) {
          this.parsed = this.$t("documentation.empty", { path: this.path })
        }
      })
  },
}
</script>
